import { pipe } from "fp";

import * as ReactRedux from "react-redux";
import { ThunkAction } from "redux-thunk";

export * from "./Definition";

import * as Document from "~/Document";
import * as Driver from "~/Driver";
import * as IndividualDriver from "~/IndividualDriver";
import * as ELD from "~/ELD";
import * as Log from "~/Log";
import { MainMenu } from "~/MainMenu";
import * as Messaging from "~/Messaging";
import * as State from "~/State";
import { Time } from "~/Time";
import * as TimeTracking from "~/TimeTracking";
import * as WorkCode from "~/WorkCode";

import { FromCreator } from "./Definition";

export type Action = FromCreator<ReturnType<typeof actions>[number]["create"]>;

// TODO: all actions must be registered here or they will fail silently (their reducers won't run). Update so this fails in a more obvious way
export const actions = () =>
  [
    Document.Action.Requested,
    Document.Action.Received,
    Document.Sort.Action.Updated,
    Document.Search.Action.Updated,
    Document.Detail.Action.Updated,
    Document.Detail.Action.Cleared,
    Driver.Action.Requested,
    Driver.Action.Received,
    Driver.Action.Filtered.Requested,
    Driver.Action.Filtered.Received,
    IndividualDriver.Action.Requested,
    IndividualDriver.Action.Received,
    Driver.Sort.Action.Updated,
    Driver.Search.Action.Updated,
    Driver.Filter.Action.Location.Updated,
    Driver.Filter.Action.Branch.Updated,
    IndividualDriver.DriverId.Action.Updated,
    ELD.Action.Requested,
    ELD.Action.Received,
    ELD.Sort.Action.Updated,
    ELD.Search.Action.Updated,
    ELD.Interval.Action.Updated,
    ELD.Submission.Status.Action.Requested,
    ELD.Submission.Status.Action.Received,
    Log.Action.Requested,
    Log.Action.Received,
    MainMenu.Action,
    Messaging.Action.Requested,
    Messaging.Action.Received,
    Messaging.Search.Action.Updated,
    Messaging.MessageInteraction.Send.Action.Requested,
    Messaging.Summary.Action.Requested,
    Messaging.Summary.Action.Received,
    Messaging.MessageInteraction.Action.Updated,
    Messaging.MessageInteraction.Action.Cleared,
    Time.Zone.Action,
    TimeTracking.Entry.Action.Requested,
    TimeTracking.Entry.Action.Received,
    WorkCode.Action.Requested,
    WorkCode.Action.Received,
  ] as const;

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useDispatch = () => ReactRedux.useDispatch();

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useAction = (
  action: Action | ThunkAction<Action, State.State, undefined, Action>
) => pipe(useDispatch(), (dispatch) => () => dispatch(action));
